(function () {
  function initialiseEssenzaProduct(root) {
    var scope = root || document;
    var product = scope.querySelector
      ? scope.querySelector('[data-testid="product-information"]')
      : null;

    if (!product && scope.matches && scope.matches('[data-testid="product-information"]')) {
      product = scope;
    }
    if (!product || product.dataset.egPremiumBound === 'true') return;

    product.dataset.egPremiumBound = 'true';

    var reducedMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!reducedMotion) {
      document.body.classList.add('eg-product-enhanced');
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          document.body.classList.add('eg-product-visible');
        });
      });
    }

    var media = product.querySelector('.product-information__media');
    if (media && !reducedMotion && window.matchMedia('(pointer: fine)').matches) {
      var pointerFrame = 0;
      media.addEventListener('pointermove', function (event) {
        if (pointerFrame) window.cancelAnimationFrame(pointerFrame);
        pointerFrame = window.requestAnimationFrame(function () {
          var rect = product.getBoundingClientRect();
          var x = ((event.clientX - rect.left) / rect.width) * 100;
          var y = ((event.clientY - rect.top) / rect.height) * 100;
          product.style.setProperty('--eg-pointer-x', Math.max(0, Math.min(100, x)) + '%');
          product.style.setProperty('--eg-pointer-y', Math.max(0, Math.min(100, y)) + '%');
        });
      });
      media.addEventListener('pointerleave', function () {
        product.style.setProperty('--eg-pointer-x', '16%');
        product.style.setProperty('--eg-pointer-y', '22%');
      });
    }

    var story = document.querySelector('.eg-story');
    if (!story || story.dataset.egPremiumBound === 'true') return;
    story.dataset.egPremiumBound = 'true';

    var revealItems = story.querySelectorAll(
      '.eg-story__opening, .eg-story__notes-heading, .eg-story__details-title, .eg-story__accordion details'
    );

    if (reducedMotion || !('IntersectionObserver' in window)) {
      revealItems.forEach(function (item) {
        item.classList.add('is-revealed');
      });
    } else {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.14 });

      revealItems.forEach(function (item) {
        item.classList.add('eg-reveal');
        observer.observe(item);
      });
    }

    var details = story.querySelectorAll('.eg-story__accordion details');
    details.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        details.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  }

  function boot() {
    initialiseEssenzaProduct(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialiseEssenzaProduct(event.target);
  });
})();
